(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coming-soon"]) return;
  try {
    
  (function () {
    var toggle = document.getElementById('cs-pw-toggle');
    var dialog = document.getElementById('cs-pw-dialog');
    var close = document.getElementById('cs-pw-close');
    if (!toggle || !dialog || typeof dialog.showModal !== 'function') return;

    toggle.addEventListener('click', function () {
      dialog.showModal();
    });

    close.addEventListener('click', function () {
      dialog.close();
    });

    if (document.getElementById('cs-pw-errors')) dialog.showModal();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
